"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCardSelectBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var bc_input_behavior_1 = require("../bc-input/bc-input-behavior");
var bc_abstract_dropdown_behavior_1 = require("../bc-dropdown/bc-abstract-dropdown-behavior");
var input_constants_1 = require("../input/input-constants");
var bc_card_product_constants_1 = require("../bc-card-product/bc-card-product-constants");
var bc_card_product_constants_2 = require("../bc-card-product/bc-card-product-constants");
var bc_card_select_constants_1 = require("./bc-card-select-constants");
var bc_card_select_constants_2 = require("./bc-card-select-constants");
var bc_card_select_constants_3 = require("./bc-card-select-constants");
var bc_card_select_constants_4 = require("./bc-card-select-constants");
var bc_card_select_constants_5 = require("./bc-card-select-constants");
var bc_card_select_constants_6 = require("./bc-card-select-constants");
var bc_card_select_constants_7 = require("./bc-card-select-constants");
var bc_card_select_constants_8 = require("./bc-card-select-constants");
var bc_card_select_constants_9 = require("./bc-card-select-constants");
var bc_card_select_constants_10 = require("./bc-card-select-constants");
var bc_card_select_constants_11 = require("./bc-card-select-constants");
var bc_card_select_constants_12 = require("./bc-card-select-constants");
var bc_card_select_constants_13 = require("./bc-card-select-constants");
var bc_card_select_constants_14 = require("./bc-card-select-constants");
var bc_card_select_constants_15 = require("./bc-card-select-constants");
var bc_card_select_constants_16 = require("./bc-card-select-constants");
var bc_card_select_constants_17 = require("./bc-card-select-constants");
var bc_card_select_constants_18 = require("./bc-card-select-constants");
var bc_card_select_constants_19 = require("./bc-card-select-constants");
var bc_card_select_constants_20 = require("./bc-card-select-constants");
var bc_card_select_constants_21 = require("./bc-card-select-constants");
var bc_card_select_constants_22 = require("./bc-card-select-constants");
var bc_card_select_constants_23 = require("./bc-card-select-constants");
var bc_card_product_config_1 = require("../bc-card-product/bc-card-product-config");
var bc_card_product_behavior_1 = require("../bc-card-product/bc-card-product-behavior");
var bc_abstract_dropdown_constants_1 = require("../bc-dropdown/bc-abstract-dropdown-constants");
var bc_card_select_constants_24 = require("./bc-card-select-constants");
var bc_card_select_constants_25 = require("./bc-card-select-constants");
var bc_card_select_constants_26 = require("./bc-card-select-constants");
var bc_card_select_constants_27 = require("./bc-card-select-constants");
var bc_card_select_constants_28 = require("./bc-card-select-constants");
var bc_card_select_constants_29 = require("./bc-card-select-constants");
var bc_card_select_constants_30 = require("./bc-card-select-constants");
var BcCardSelectBehavior = (function (_super) {
    __extends(BcCardSelectBehavior, _super);
    function BcCardSelectBehavior() {
        var _this = _super.call(this) || this;
        _this.activeElement = null;
        _this.bcCardProductBehavior = null;
        _this.selectedItemsDisplay = '{0} ítems seleccionados';
        _this.bcInputBehavior = new bc_input_behavior_1.BcInputBehavior();
        _this.oldValue = common_constants_1.COMMON_CONSTANTS_NUMBERS.N0;
        _this.newValue = common_constants_1.COMMON_CONSTANTS_NUMBERS.N0;
        _this.createItemsFlag = true;
        return _this;
    }
    BcCardSelectBehavior.prototype._setUp = function () {
        var _this = this;
        this.setDropDownConfiguration();
        this.getDropdownContent();
        _super.prototype._setUp.call(this);
        this.bcInputBehavior.setElement(this.mySelf.querySelector('input'));
        this.bcInputBehavior.setUp();
        this.getInsideElements();
        this.setMarginTop();
        this.setupPlaceHolder();
        if (this.createItemsFlag) {
            this.createItems();
        }
        this.setEventListeners();
        this.markItemByIndex(this.defaultIndex);
        this.setupAccessibility();
        this.setEventClickOutside();
        this.setResponsive();
        this.emitEvent = function () {
            _this.setPositionFixedContentBody();
        };
    };
    BcCardSelectBehavior.prototype.setDisable = function (status) {
        var controlContent = this.mySelf.querySelector(("*[class~='".concat(bc_card_select_constants_2.CARD_SELECT_CONTROL_CLASS, "']")));
        if (status) {
            this.closeDropdown();
            controlContent.classList.add(bc_card_select_constants_29.CARD_SELECT_CONTROL_DISABLED_CLASS);
        }
        else {
            controlContent.classList.remove(bc_card_select_constants_29.CARD_SELECT_CONTROL_DISABLED_CLASS);
        }
    };
    BcCardSelectBehavior.prototype.createItems = function () {
        var _this = this;
        if (this.itemsConfig && this.itemsConfig.length) {
            this.dropdownItems = [];
            this.itemsConfig.forEach(function (itemObj, i) {
                var li = _this.createCardItem(itemObj);
                _this.dropdownItems[i] = li;
            });
            var bodyContent = this.dropdownContent.querySelector(("*[class~='".concat(bc_card_select_constants_16.CARD_SELECT_DROPDOWN_BODY_CLASS, "']")));
            bodyContent.innerHTML = '';
            bodyContent.appendChild((0, helpers_1.createElement)({
                element: common_constants_1.BcCommonConstants.UL_TAG,
                classList: ["bc-mt-1"],
                children: this.dropdownItems
            }));
        }
    };
    BcCardSelectBehavior.prototype.setItems = function (items, sizeFont) {
        this.sizeFont = sizeFont;
        this.cleanItems();
        this.itemsConfig = items;
        if (this.itemsConfig) {
            this.itemsConfig.forEach(function (value) {
                value.size = sizeFont;
            });
        }
    };
    BcCardSelectBehavior.prototype.setMarginTop = function () {
        if (this.span) {
            this.topMarginContent = -25;
        }
    };
    BcCardSelectBehavior.prototype.toEnumValue = function (enumValue) {
        if (typeof enumValue === 'string') {
            var enumType = enumValue;
            return bc_card_product_config_1.BcCardProductSizeFont[enumType];
        }
        return enumValue;
    };
    BcCardSelectBehavior.prototype.getPlaceHolderClass = function () {
        var classPlaceHolder;
        switch (this.toEnumValue(this.sizeFont)) {
            case bc_card_product_config_1.BcCardProductSizeFont.normal:
                classPlaceHolder = bc_card_select_constants_6.CARD_SELECT_PLACEHOLDER_CLASS;
                break;
            case bc_card_product_config_1.BcCardProductSizeFont.medium:
                classPlaceHolder = bc_card_select_constants_22.CARD_SELECT_PLACEHOLDER_MEDIUM_CLASS;
                break;
            case bc_card_product_config_1.BcCardProductSizeFont.large:
                classPlaceHolder = bc_card_select_constants_23.CARD_SELECT_PLACEHOLDER_LARGE_CLASS;
                break;
            default:
                classPlaceHolder = bc_card_select_constants_6.CARD_SELECT_PLACEHOLDER_CLASS;
                break;
        }
        return classPlaceHolder;
    };
    BcCardSelectBehavior.prototype.setupPlaceHolder = function () {
        var _this = this;
        var classPlaceHolder = this.getPlaceHolderClass();
        this.cardSelectInput = this.mySelf.querySelector(".".concat(bc_card_select_constants_4.CARD_SELECT_INPUT_CLASS));
        if (this.cardSelectInput) {
            this.selectControl = this.mySelf.querySelector(".".concat(bc_card_select_constants_2.CARD_SELECT_CONTROL_CLASS));
            var label = this.cardSelectInput.querySelector("label");
            this.placeHolder = document.createElement("label");
            this.placeHolder.innerHTML = label.innerHTML;
            var placeHolder = this.getFirstElementByClassName(bc_card_select_constants_6.CARD_SELECT_PLACEHOLDER_CLASS);
            var placeHolderMedium = this.getFirstElementByClassName(bc_card_select_constants_22.CARD_SELECT_PLACEHOLDER_MEDIUM_CLASS);
            var placeHolderLarge = this.getFirstElementByClassName(bc_card_select_constants_23.CARD_SELECT_PLACEHOLDER_LARGE_CLASS);
            if (!placeHolder && !placeHolderMedium && !placeHolderLarge) {
                this.placeHolder.classList.add("".concat(bc_card_select_constants_8.CARD_SELECT_SUBTITLE_CLASS), "".concat(classPlaceHolder));
                this.setupSelectControlAccesibility(false);
                this.cardSelectInput.parentNode.insertBefore(this.placeHolder, this.cardSelectInput.nextSibling || null);
                this.cardSelectInput.style.display = 'none';
            }
            window.addEventListener(bc_abstract_dropdown_constants_1._DROPDOWN_OPENED_EVENT, function (data) {
                _this.setupSelectControlAccesibility(true);
                _this.showPlaceHolder(data, false);
            });
            window.addEventListener(bc_abstract_dropdown_constants_1._DROPDOWN_CLOSED_EVENT, function (data) {
                _this.setupSelectControlAccesibility(false);
                _this.showPlaceHolder(data);
                _this.setupDropDownAccessibility();
                _this.setupCardAccessibility();
            });
        }
    };
    BcCardSelectBehavior.prototype.setupAccessibility = function () {
        var dropdownFooter = this.dropdownContent.querySelector("*[class~='".concat(bc_card_select_constants_18.CARD_SELECT_DROPDOWN_FOOTER_CLASS, "']"));
        (0, helpers_1.addFocusable)(dropdownFooter, { "role": "button", "tabindex": "0" });
        var dropdownBody = this.dropdownContent.querySelector("*[class~='".concat(bc_card_select_constants_16.CARD_SELECT_DROPDOWN_BODY_CLASS, "']"));
        var cardsInfo = dropdownBody.querySelectorAll(".".concat(bc_card_select_constants_3.CARD_SELECT_INFO_CLASS));
        cardsInfo === null || cardsInfo === void 0 ? void 0 : cardsInfo.forEach(function (item) {
            if (item.innerHTML.length > 0) {
                var ariaLabel = "Saldo de cuenta: ".concat(item.innerHTML.replace('$', ''), " pesos colombianos");
                item.setAttribute('aria-label', ariaLabel);
            }
        });
        this.setupBodyAccessibility();
        this.setupCardAccessibility();
        this.setupDropDownAccessibility();
    };
    BcCardSelectBehavior.prototype.setupBodyAccessibility = function () {
        var _this = this;
        var dropdownBody = this.dropdownContent.querySelector("*[class~='".concat(bc_card_select_constants_16.CARD_SELECT_DROPDOWN_BODY_CLASS, "']"));
        dropdownBody.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            _this.processKeyDown(event, dropdownBody);
        });
    };
    BcCardSelectBehavior.prototype.processKeyDown = function (event, dropdownBody) {
        var currentItem = dropdownBody.querySelector("li.".concat(bc_card_select_constants_5.CARD_SELECT_OUTLINE_ELEMENT));
        var nextItem;
        if (currentItem) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_UP || event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
                nextItem = this.processArrowUp(event, nextItem, currentItem);
                if (nextItem) {
                    this.focusNextItem(currentItem, nextItem);
                }
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_END || event.key === common_constants_1.BcCommonConstants.KEY_EVENT_HOME) {
                var items = dropdownBody.querySelectorAll(".".concat(bc_card_select_constants_17.CARD_SELECT_DROPDOWN_ITEM_CLASS));
                nextItem = this.processArrowEnd(event, nextItem, items);
                if (nextItem) {
                    this.focusNextItem(currentItem, nextItem);
                }
            }
        }
    };
    BcCardSelectBehavior.prototype.processArrowEnd = function (event, nextItem, items) {
        if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_END) {
            nextItem = items[items.length - 1];
        }
        else {
            nextItem = items[0];
        }
        return nextItem;
    };
    BcCardSelectBehavior.prototype.processArrowUp = function (event, nextItem, currentItem) {
        if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_UP) {
            nextItem = currentItem.previousElementSibling;
        }
        else {
            nextItem = currentItem.nextElementSibling;
        }
        return nextItem;
    };
    BcCardSelectBehavior.prototype.setupCardAccessibility = function () {
        if (this.activeElement) {
            this.selectControl.removeAttribute("tabindex");
            (0, helpers_1.addFocusable)(this.mySelf, { tabindex: '0' });
        }
        else {
            this.mySelf.removeAttribute("tabindex");
            (0, helpers_1.addFocusable)(this.selectControl, { tabindex: '0' });
        }
    };
    BcCardSelectBehavior.prototype.setupSelectControlAccesibility = function (expanded) {
        var _a;
        this.selectControl.setAttribute("aria-label", "".concat((_a = this.placeHolder) === null || _a === void 0 ? void 0 : _a.innerHTML, ", men\u00FA desplegable, ").concat(expanded ? 'Expandido' : 'Contraido'));
    };
    BcCardSelectBehavior.prototype.setupDropDownAccessibility = function () {
        var dropDown = this.mySelf.querySelector("em.".concat("arrow-direction"));
        (0, helpers_1.addFocusable)(dropDown, { tabindex: "0" });
        dropDown === null || dropDown === void 0 ? void 0 : dropDown.setAttribute("aria-label", "Cambiar producto, men\u00FA desplegable");
    };
    BcCardSelectBehavior.prototype.focusNextItem = function (currentItem, nextItem) {
        currentItem.classList.remove("".concat(bc_card_select_constants_5.CARD_SELECT_OUTLINE_ELEMENT));
        nextItem.classList.add("".concat(bc_card_select_constants_5.CARD_SELECT_OUTLINE_ELEMENT));
        nextItem.focus();
    };
    BcCardSelectBehavior.prototype.showPlaceHolder = function (dropDownId, show) {
        if (show === void 0) { show = true; }
        var dropDown = this.mySelf.querySelector("[aria-controls=\"".concat(dropDownId.detail, "\"]"));
        if (dropDown) {
            var selectedCard = this.mySelf.querySelector(".".concat(bc_card_select_constants_11.CARD_SELECT_ACTIVE_ITEM_CLASS));
            if (!selectedCard) {
                if (!show) {
                    this.cardSelectInput.style.display = common_constants_1.BcCommonConstants.BLOCK;
                    this.placeHolder.style.display = common_constants_1.BcCommonConstants.NONE;
                    if (this.input) {
                        this.input.focus();
                    }
                }
                else {
                    this.cardSelectInput.style.display = common_constants_1.BcCommonConstants.NONE;
                    this.placeHolder.style.display = common_constants_1.BcCommonConstants.BLOCK;
                }
            }
            else {
                this.showSelectedCard(selectedCard, show);
            }
        }
    };
    BcCardSelectBehavior.prototype.showSelectedCard = function (selectedCard, show) {
        if (show === void 0) { show = true; }
        this.cardSelectInput.style.display = common_constants_1.BcCommonConstants.BLOCK;
        if (!show) {
            this.selectControl.style.display = common_constants_1.BcCommonConstants.FLEX;
            this.placeHolder.style.display = common_constants_1.BcCommonConstants.NONE;
            selectedCard.style.display = common_constants_1.BcCommonConstants.NONE;
            if (this.input) {
                this.input.focus();
            }
        }
        else {
            this.selectControl.style.display = common_constants_1.BcCommonConstants.NONE;
            var activeSelectedCard = this.validateShow(selectedCard);
            if (activeSelectedCard) {
                selectedCard.style.display = common_constants_1.BcCommonConstants.BLOCK;
            }
        }
    };
    BcCardSelectBehavior.prototype.validateShow = function (selectedCard) {
        var contentActive = this.mySelf.getElementsByClassName(bc_card_select_constants_15.CARD_SELECT_DROPDOWN_ACTIVE_CLASS).item(0);
        if (contentActive) {
            if (selectedCard && this.selectControl.style.display == common_constants_1.BcCommonConstants.NONE) {
                this.showSelectedCard(selectedCard, false);
                return false;
            }
        }
        else {
            return true;
        }
    };
    BcCardSelectBehavior.prototype.setSelectedItemsDisplay = function (displayInfo) {
        if (displayInfo) {
            this.selectedItemsDisplay = displayInfo;
        }
    };
    BcCardSelectBehavior.prototype.setDefaultIndex = function (index) {
        this.defaultIndex = index;
    };
    BcCardSelectBehavior.prototype.setDefaultValue = function (value) {
        if (typeof value == 'undefined') {
            return;
        }
        if (!this.itemsConfig) {
            return;
        }
        var filtered = this.itemsConfig.find(function (e) { return e.value == value; });
        if (filtered) {
            var index = this.itemsConfig.indexOf(filtered);
            this.markItemByIndex(index);
            this.defaultIndex = index;
        }
    };
    BcCardSelectBehavior.prototype.getInsideElements = function () {
        this.input = this.mySelf.querySelector("".concat(common_constants_1.BcCommonConstants.INPUT_TAG, "[class=").concat(input_constants_1.INPUT, "]"));
        if (!this.itemsConfig) {
            this.getItems();
        }
    };
    BcCardSelectBehavior.prototype.getItems = function () {
        var _this = this;
        this.cleanItems();
        var items = Array.from(this.mySelf.querySelectorAll("*[class=".concat(bc_card_select_constants_17.CARD_SELECT_DROPDOWN_ITEM_CLASS, "]")));
        items.forEach(function (item, i) {
            var card = _this.toCardComponent(item, false);
            _this.itemsConfig[i] = card.getConfig();
            _this.dropdownItems[i] = item;
        });
    };
    BcCardSelectBehavior.prototype.setDropDownConfiguration = function () {
        this.setConfig({
            toggleClass: bc_card_select_constants_12.CARD_SELECT_TOGGLE_CLASS,
            toggleActiveClass: bc_card_select_constants_13.CARD_SELECT_ACTIVE_TOGGLE_CLASS,
            contentClass: bc_card_select_constants_14.CARD_SELECT_DROPDOWN_CLASS,
            contentActiveClass: bc_card_select_constants_15.CARD_SELECT_DROPDOWN_ACTIVE_CLASS,
            itemClass: bc_card_select_constants_17.CARD_SELECT_DROPDOWN_ITEM_CLASS,
            triangleClass: bc_card_select_constants_17.CARD_SELECT_DROPDOWN_ITEM_CLASS,
            extraToggles: [
                {
                    node: this.input,
                    events: ['focus'],
                },
            ],
            toggleEvents: ['click', 'input'],
            mainClass: bc_card_select_constants_1.CARD_SELECT_CLASS,
            mainActiveClass: bc_card_select_constants_9.CARD_SELECT_ACTIVE_CLASS,
            static: true,
            isPopUp: false,
            parentWidth: true,
            onlyBottomPosition: true
        });
    };
    BcCardSelectBehavior.prototype.getCurrentActiveItem = function () {
        if (!this.activeElement) {
            var activeCard = this.mySelf.querySelector("div[class=".concat(bc_card_select_constants_11.CARD_SELECT_ACTIVE_ITEM_CLASS, "]"));
            if (activeCard) {
                var card = this.toCardComponent(activeCard, true);
                this.setActiveItem(card);
            }
        }
        return this.activeElement;
    };
    BcCardSelectBehavior.prototype.setFormatOutput = function (formatType) {
        if (formatType && (formatType === 'simple' || formatType === 'full')) {
            this.formatType = formatType;
        }
    };
    BcCardSelectBehavior.prototype.markItemByIndex = function (index) {
        var items = this.mySelf.querySelectorAll(("li[class~='".concat(bc_card_select_constants_17.CARD_SELECT_DROPDOWN_ITEM_CLASS, "']")));
        if (index !== undefined && this.dropdownItems.length > index && index >= 0 && items.length > 0) {
            this.bcInputBehavior.addRemoveClass(true, this.mySelf.querySelector('input'));
            this.dropdownItems[String(index)].dispatchEvent(new Event(common_constants_1.BcCommonConstants.EVENT_CLICK, {}));
        }
    };
    BcCardSelectBehavior.prototype.configSelectedEvent = function (event, i, item) {
        if (this.disabled) {
            return;
        }
        this.removeSelectedItem(item);
        this.showSelectedItem(item);
        this.closeDropdown();
        this.showAllItems();
        this.removeFilter();
        this.activeElement = this.itemsConfig[i];
        if (this.outputFunction) {
            this.outputFunction(this.itemsConfig[i]);
        }
        this.sortDropdownItems();
    };
    BcCardSelectBehavior.prototype.sortDropdownItems = function () {
        var dropdownBody = this.dropdownContent.querySelector("*[class~='".concat(bc_card_select_constants_16.CARD_SELECT_DROPDOWN_BODY_CLASS, "']"));
        var ulChild = dropdownBody.firstChild;
        var liChildren = ulChild.childNodes;
        var arrayItems = Array.from(liChildren);
        if (arrayItems.length > 0) {
            arrayItems.forEach(function (currentValue, index) {
                if (currentValue['classList'] && currentValue['classList'].contains(bc_card_select_constants_7.CARD_SELECT_SELECTED_ITEM_CLASS)) {
                    arrayItems.unshift(currentValue);
                    arrayItems.splice(index + 1, 1);
                }
            });
        }
        arrayItems.forEach(function (li) {
            ulChild.appendChild(li);
        });
        this.setPositionFixedContentBody();
    };
    BcCardSelectBehavior.prototype.setEventListeners = function () {
        var _this = this;
        this.dropdownItems.forEach(function (item) {
            item.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                event.stopPropagation();
                event.preventDefault();
                _this.configSelectedEvent(event, _this.dropdownItems.indexOf(item), item);
            });
            (0, helpers_1.addFocusable)(item, { tabindex: '0' }, { event: _this.configSelectedEvent.bind(_this, {}, _this.dropdownItems.indexOf(item), item) });
        });
        this.mySelf.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            _this.filterItemsEvent(event);
        });
        window.addEventListener(common_constants_1.BcCommonConstants.SCROLL, function (event) {
            var e = event.target;
            _this.newValue = e.scrollTop;
            var element = _this.dropdownContent.querySelector("*[class~='".concat(bc_card_select_constants_16.CARD_SELECT_DROPDOWN_BODY_CLASS, "']"));
            var typePosition = getComputedStyle(element).position;
            if ((_this.oldValue != _this.newValue) && e.scrollHeight > bc_card_select_constants_30.CARD_SELECT_SCROLL_MIN && typePosition === 'fixed') {
                _this.closeDropdown();
                _this.setPositionFixedContentBody();
            }
            _this.oldValue = _this.newValue;
        }, true);
    };
    BcCardSelectBehavior.prototype.setPositionFixedContentBody = function () {
        if (this.dropdownContent) {
            var contentBody = this.dropdownContent.querySelector("*[class~='".concat(bc_card_select_constants_16.CARD_SELECT_DROPDOWN_BODY_CLASS, "']"));
            var coords = this.mySelf.getBoundingClientRect();
            contentBody['style'].top = coords.top + coords.height - common_constants_1.COMMON_CONSTANTS_NUMBERS.N2 + 'px';
        }
    };
    BcCardSelectBehavior.prototype.filterItemsEvent = function (event) {
        if (typeof event.target.value === "string") {
            var value = event.target.value.toUpperCase();
            if (value.length >= bc_card_select_constants_1.CARD_SELECT_MIN_FILTER_CHA) {
                this.filterDropdown();
            }
            else {
                this.showAllItems();
            }
            this.setIconNotData();
        }
    };
    BcCardSelectBehavior.prototype.filterDropdown = function () {
        var _this = this;
        var valueInput = this.getFirstElementByClassName(bc_card_select_constants_24.CARD_SELECT_INPUT)['value'].toUpperCase();
        if (this.input) {
            this.input.value = this.getFirstElementByClassName(bc_card_select_constants_24.CARD_SELECT_INPUT)['value'];
        }
        if (valueInput.length >= bc_card_select_constants_1.CARD_SELECT_MIN_FILTER_CHA) {
            this.restoreFilters();
            var itemsFound_1 = false;
            this.itemsConfig.forEach(function (config, i) {
                var thisString = Object.values(config).map(function (el) {
                    return typeof el === "string" ? el.toUpperCase() : '';
                }).join();
                var subTitle = config.subtittle.toString().toUpperCase();
                thisString = "".concat(thisString, ",").concat(subTitle);
                if (thisString.indexOf(valueInput) >= 0) {
                    itemsFound_1 = true;
                    _this.dropdownItems[i].classList.add(bc_card_select_constants_21.CARD_SELECT_DROPDOWN_FILTERED_ITEMS_CLASS);
                }
            });
            if (itemsFound_1) {
                this.openDrowndown();
            }
        }
        else {
            this.showAllItems();
        }
    };
    BcCardSelectBehavior.prototype.returnValueInput = function () {
        return this.getFirstElementByClassName(bc_card_select_constants_24.CARD_SELECT_INPUT)['value'];
    };
    BcCardSelectBehavior.prototype.getFirstElementByClassName = function (className) {
        var elements = this.mySelf.getElementsByClassName(className);
        var node = null;
        if (elements.length > 0) {
            node = elements[0];
        }
        return node;
    };
    BcCardSelectBehavior.prototype.showAllItems = function () {
        this.dropdownContent.classList.remove(bc_card_select_constants_20.CARD_SELECT_DROPDOWN_FILTRABLE_ITEMS_CLASS);
    };
    BcCardSelectBehavior.prototype.restoreFilters = function () {
        if (this.dropdownContent) {
            this.dropdownContent.classList.add(bc_card_select_constants_20.CARD_SELECT_DROPDOWN_FILTRABLE_ITEMS_CLASS);
            this.dropdownItems.forEach(function (item) {
                item.classList.remove(bc_card_select_constants_21.CARD_SELECT_DROPDOWN_FILTERED_ITEMS_CLASS);
            });
        }
    };
    BcCardSelectBehavior.prototype.removeItemsSelection = function () {
        if (this.dropdownItems) {
            this.dropdownItems.forEach(function (item) {
                item.classList.remove(bc_card_select_constants_7.CARD_SELECT_SELECTED_ITEM_CLASS);
            });
        }
    };
    BcCardSelectBehavior.prototype.removeFilter = function () {
        if (this.input) {
            this.input.value = '';
        }
    };
    BcCardSelectBehavior.prototype.toCardComponent = function (element, isActive, toggleEvent) {
        var card = element.querySelector("div[class~=".concat(bc_card_product_constants_1.CARD_MAIN_CLASS, "]")).cloneNode(true);
        var cardItem = new bc_card_product_behavior_1.BcCardProductBehavior();
        cardItem.setElement(card);
        if (toggleEvent) {
            cardItem.toggleAction = toggleEvent.bind(this);
        }
        cardItem.setUp();
        cardItem.setActive(isActive);
        return cardItem;
    };
    BcCardSelectBehavior.prototype.removeSelectedItem = function (item) {
        var selectedItem = this.mySelf.querySelector("div[class~=".concat(bc_card_select_constants_11.CARD_SELECT_ACTIVE_ITEM_CLASS, "]"));
        this.removeItemsSelection();
        if (selectedItem) {
            selectedItem.remove();
        }
        this.mySelf.classList.remove(bc_card_select_constants_10.CARD_SELECT_SELECTED_CLASS);
        item.classList.add(bc_card_select_constants_7.CARD_SELECT_SELECTED_ITEM_CLASS);
        this.setActiveItem(null);
    };
    BcCardSelectBehavior.prototype.showSelectedItem = function (item) {
        var card = this.toCardComponent(item, true, this.clickToggleEvent);
        this.setActiveItem(card);
        this.mySelf.classList.add(bc_card_select_constants_10.CARD_SELECT_SELECTED_CLASS);
        this.mySelf.prepend((0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_select_constants_11.CARD_SELECT_ACTIVE_ITEM_CLASS],
            children: [
                card.getMySelf(),
            ]
        }));
    };
    BcCardSelectBehavior.prototype.setActiveItem = function (card) {
        if (card) {
            this.activeElement = card.getConfig();
            this.bcCardProductBehavior = card;
            return;
        }
        this.activeElement = null;
        this.bcCardProductBehavior = null;
    };
    BcCardSelectBehavior.prototype.getDropdownContent = function () {
        this.getDropdownParent();
        this.getDropdownBody();
        if (this.dropdownButtonConfig) {
            this.getDropdownFooter();
        }
    };
    BcCardSelectBehavior.prototype.getDropdownFooter = function () {
        var dropdownFooter = this.dropdownContent.querySelector("*[class~='".concat(bc_card_select_constants_18.CARD_SELECT_DROPDOWN_FOOTER_CLASS, "']"));
        if (dropdownFooter) {
            this.addDropdownButtonEventClick(dropdownFooter);
            return;
        }
        dropdownFooter = this.createDropDownFooter();
        this.dropdownContent.appendChild(dropdownFooter);
        this.addDropdownButtonEventClick(dropdownFooter);
    };
    BcCardSelectBehavior.prototype.createDropDownFooter = function () {
        var buttonConfig = this.dropdownButtonConfig;
        var divContent = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_select_constants_19.CARD_SELECT_DROPDOWN_FOOTER_ITEM_CLASS],
            children: [
                (0, helpers_1.createElement)({
                    element: common_constants_1.BcCommonConstants.LABEL_TAG,
                    innerText: buttonConfig.text
                }),
                (0, helpers_1.createElement)({
                    element: common_constants_1.BcCommonConstants.EM_TAG,
                    classList: [common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_SM_CLASS],
                    props: {
                        'aria-hidden': 'true'
                    },
                    innerText: buttonConfig.icon
                }),
            ]
        });
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_select_constants_18.CARD_SELECT_DROPDOWN_FOOTER_CLASS],
            children: [divContent]
        });
    };
    BcCardSelectBehavior.prototype.setIconNotData = function () {
        var filtrable = this.dropdownContent.classList.contains(bc_card_select_constants_20.CARD_SELECT_DROPDOWN_FILTRABLE_ITEMS_CLASS);
        var countFilteredItems = 0;
        if (this.dropdownItems) {
            this.dropdownItems.forEach(function (item) {
                if (item.classList.contains(bc_card_select_constants_21.CARD_SELECT_DROPDOWN_FILTERED_ITEMS_CLASS)) {
                    countFilteredItems++;
                }
            });
        }
        if (((filtrable && countFilteredItems === 0) || (this.itemsConfig.length === 0))) {
            this.viewIconNotData(true);
        }
        else {
            this.viewIconNotData(false);
        }
    };
    BcCardSelectBehavior.prototype.viewIconNotData = function (value) {
        var contentNotData = this.mySelf.querySelector("*[class~='".concat(bc_card_select_constants_25.CARD_SELECT_DROPDOWN_CONTENT_NOTDATA, "']"));
        var contentNotDataVisible = this.mySelf.querySelector("*[class~='".concat(bc_card_select_constants_26.CARD_SELECT_DROPDOWN_CONTENT_VISIBLE, "']"));
        if (value && contentNotData) {
            contentNotData.classList.replace(bc_card_select_constants_25.CARD_SELECT_DROPDOWN_CONTENT_NOTDATA, bc_card_select_constants_26.CARD_SELECT_DROPDOWN_CONTENT_VISIBLE);
        }
        else if (!value && contentNotDataVisible) {
            contentNotDataVisible.classList.replace(bc_card_select_constants_26.CARD_SELECT_DROPDOWN_CONTENT_VISIBLE, bc_card_select_constants_25.CARD_SELECT_DROPDOWN_CONTENT_NOTDATA);
        }
    };
    BcCardSelectBehavior.prototype.createDropDownNotdata = function () {
        var iconNotData = this.mySelf.querySelector("*[class~='".concat(bc_card_select_constants_28.CARD_SELECT_DROPDOWN_ICON_NOTDATA, "']"));
        var notData = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_select_constants_27.CARD_SELECT_JUSTIFY, bc_card_select_constants_25.CARD_SELECT_DROPDOWN_CONTENT_NOTDATA],
            children: [iconNotData]
        });
        if (!this.mySelf.querySelector("*[class~='".concat(bc_card_select_constants_25.CARD_SELECT_DROPDOWN_CONTENT_NOTDATA, "']"))) {
            this.dropdownContent.appendChild(notData);
            this.setIconNotData();
        }
    };
    BcCardSelectBehavior.prototype.addDropdownButtonEventClick = function (footerElement) {
        var _this = this;
        footerElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.dropdownButtonConfig.event(event);
        });
        (0, helpers_1.addFocusable)(footerElement, {}, { event: this.dropdownButtonConfig.event });
    };
    BcCardSelectBehavior.prototype.getDropdownBody = function () {
        var dropdownBody = this.dropdownContent.querySelector("*[class~='".concat(bc_card_select_constants_16.CARD_SELECT_DROPDOWN_BODY_CLASS, "']"));
        if (!dropdownBody) {
            this.dropdownContent.appendChild((0, helpers_1.createElement)({
                element: common_constants_1.BcCommonConstants.DIV_TAG,
                classList: [bc_card_select_constants_16.CARD_SELECT_DROPDOWN_BODY_CLASS]
            }));
        }
    };
    BcCardSelectBehavior.prototype.getDropdownParent = function () {
        var dropdownParent = this.mySelf.querySelector("*[class~='".concat(bc_card_select_constants_14.CARD_SELECT_DROPDOWN_CLASS, "']"));
        if (dropdownParent) {
            this.dropdownContent = dropdownParent;
            return;
        }
        var idCardSelect = this.mySelf.getAttribute('id');
        var contentId = "".concat(idCardSelect, "-content");
        dropdownParent = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_select_constants_14.CARD_SELECT_DROPDOWN_CLASS],
            props: {
                id: contentId,
            },
        });
        this.mySelf.appendChild(dropdownParent);
        this.dropdownContent = dropdownParent;
    };
    BcCardSelectBehavior.prototype.cleanItems = function () {
        this.itemsConfig = [];
        this.dropdownItems = [];
    };
    BcCardSelectBehavior.prototype.createCardItem = function (data) {
        var cardDiv = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_card_product_constants_1.CARD_MAIN_CLASS, "".concat(bc_card_product_constants_2.CARD_CLASS, "-").concat(String(data.cardType))],
        });
        var cardItem = new bc_card_product_behavior_1.BcCardProductBehavior();
        cardItem.setElement(cardDiv);
        cardItem.setConfig(data);
        cardItem.setUp();
        cardItem.build();
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.LI_TAG,
            classList: [this.config.itemClass],
            children: [cardItem.getMySelf()]
        });
    };
    BcCardSelectBehavior.prototype.setEventClickOutside = function () {
        document.addEventListener('click', function (e) {
            var element = this.mySelf;
            var parent = this.mySelf.parentNode;
            parent.classList.add(bc_card_select_constants_1.CARD_SELECT_CLASS);
            if (element && !element.contains(e.target)) {
                this.closeDropdown();
            }
        }.bind(this));
    };
    BcCardSelectBehavior.prototype.setResponsive = function () {
        var parent = this.mySelf.parentElement;
        parent.classList.add(bc_card_select_constants_1.CARD_SELECT_SIZE);
    };
    return BcCardSelectBehavior;
}(bc_abstract_dropdown_behavior_1.BcAbstractDropdownBehavior));
exports.BcCardSelectBehavior = BcCardSelectBehavior;
